import styled from 'styled-components';

import { AppDownloadQrCodeSvg } from 'components/Svgs/AppDownloadQrCodeSvg';

import { colors } from 'theme/colors';

export const SuccessQrCode = () => {
  return (
    <QrCodeWrapper>
      <AppDownloadQrCodeSvg
        width="90px"
        height="90px"
        aria-label="QR code to download our mobile app"
        aria-describedby="qr-code-text"
      />
      <QrCodeText id="qr-code-text">Scan to download</QrCodeText>
    </QrCodeWrapper>
  );
};

const QrCodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const QrCodeText = styled.p`
  margin: 0;
  color: ${colors['accent-grey500']};
`;
